import React from 'react';
import { APP_PIN_LEN } from '@/constants/appPinLock';
import { cn } from '@/lib/utils';

export function AppPinDots({ length, max = APP_PIN_LEN }: { length: number; max?: number }) {
  const shown = Math.max(max, APP_PIN_LEN);
  return (
    <div className="flex flex-nowrap items-center justify-center gap-2" aria-hidden>
      {Array.from({ length: shown }).map((_, i) => (
        <span
          key={i}
          className={cn(
            'h-2.5 w-2.5 rounded-full border border-border',
            i < length ? 'bg-foreground' : 'bg-transparent'
          )}
        />
      ))}
    </div>
  );
}
